import { createPostEndpoint } from '@sonar-software/sonar-http';
import { DynamicQueryParams } from '@sonar-software/sonar-ts-types';

export type PostDataSecurityAlertsExportRequest = DynamicQueryParams;

export type PostDataSecurityAlertsExportResponse = { id: number };

export const postDataSecurityAlertsExportStart = createPostEndpoint<
	PostDataSecurityAlertsExportRequest,
	PostDataSecurityAlertsExportResponse
>('/api/v3/core/exports/alerts/export/start');
